<mat-card-content class="w-100-p mb-0">
    <div class="p-24 stats-wrapper">
        <div fxLayout="column" class="h-full" *ngIf="!charts?.length">
            <div fxLayout="row" fxLayoutAlign="flex-start space-between" class="chart-title-wrapper mb-12">
                <div
                    fxLayoutAlign="center center"
                    class="icon-wrapper mr-8"
                    [ngStyle]="{
                        background: '#A3CAEA',
                        fill: '#A3CAEA' | colorLuminance
                    }"
                >
                    <mat-icon svgIcon="course_completion_state"></mat-icon>
                </div>
                <label fxLayout="row" fxLayoutAlign="flex-start center" class="chart-title" tabindex="0" *ngIf="!hideChartTitle">
                    {{ 'TENANT_DASHBOARD.CHART.course_completion_state' | translate }}
                    <span
                        class="ml-8 info-icon"
                        fxLayoutAlign="center center"
                        matTooltip="{{ 'TENANT_DASHBOARD.CHART.TOOLTIP.course_completion_state' | translate }}"
                        matTooltipPosition="above"
                        tabindex="0"
                    >
                        i
                    </span>
                </label>
            </div>

            <div fxLayout="row" fxLayoutAlign="center center" fxFlex="1 1 auto" class="bg-zinc-50">
                <span class="text-xs leading-5 text-gray-600 text-center tracking-widest uppercase" tabindex="0">
                    {{ 'TEAMS.TEAM_PROGRESS.LABEL.NO_PROGRESS_YET' | translate }}
                </span>
            </div>
        </div>

        <div class="chart-wrapper" *ngFor="let chart of charts">
            <div class="chart" *ngIf="chart.chartId === TenantDashboardChartId.CourseCompletionState">
                <div fxLayout="row" fxLayoutAlign="flex-start space-between" class="chart-title-wrapper mb-12">
                    <div
                        fxLayoutAlign="center center"
                        class="icon-wrapper mr-8"
                        [ngStyle]="{
                            background: '#A3CAEA',
                            fill: '#A3CAEA' | colorLuminance
                        }"
                    >
                        <mat-icon svgIcon="course_completion_state"></mat-icon>
                    </div>
                    <label fxLayout="row" fxLayoutAlign="flex-start center" class="chart-title" tabindex="0" *ngIf="!hideChartTitle">
                        {{ 'TENANT_DASHBOARD.CHART.' + chart.chartId | translate }}
                        <span
                            class="ml-8 info-icon"
                            fxLayoutAlign="center center"
                            matTooltip="{{ 'TENANT_DASHBOARD.CHART.TOOLTIP.' + chart.chartId | translate }}"
                            matTooltipPosition="above"
                            tabindex="0"
                        >
                            i
                        </span>
                    </label>
                </div>
                <div class="chart w-100-p" fxLayoutAlign="center center">
                    <div class="pie-chart-container">
                        <canvas
                            baseChart
                            tabindex="0"
                            attr.aria-label="{{ 'TENANT_DASHBOARD.CHART.' + chart.chartId | translate }} {{ 'GENERAL.LABEL.CHART' | translate }}"
                            [class]="chart.type"
                            [data]="chart.chartData"
                            [options]="chart.options"
                            [type]="chart.type"
                        >
                        </canvas>
                    </div>
                </div>
            </div>
        </div>
    </div>
</mat-card-content>
